import { InsuranceFormValues } from '../../models';

export class FetchPatientInsurances {
  static readonly type = '[Patient Insurances] Fetch Patient Insurances';
}

export class FetchPatientInsuranceCards {
  static readonly type = '[Patient Insurances] Fetch Patient Insurance Cards';
}

export class CreatePatientInsurance {
  static readonly type = '[Patient Insurances] Create Patient Insurance';
  constructor(public formValues: InsuranceFormValues) {}
}
